// extracted by mini-css-extract-plugin
export default {"btn":"buttons_btn__KxPdg"};